export default {
  orderList: {
    name2: '订单号',
    name3: '用户信息',
    name4: '用户账号',
    name5: '用户ID',
    name6: '真实姓名',
    name7: '用户昵称',
    name8: '所属平台',
    name9: '游戏',
    name10: '游戏分类',
    name11: '游戏名称',
    name12: '投注信息',
    name13: '投注期号',
    name14: '投注金额',
    name15: '中奖金额',
    name16: '奖金抽水',
    name17: '返点',
    name18: '盈亏金额',
    name19: '时间',
    name20: '投注',
    name21: '结算',
    name22: '状态',
    name23: '备注',
    name24: '操作',
    name25: '订单详情',
    name26: '账号',
    name27: '昵称',
    name28: '投注时间',
    name29: '结算时间',
    name30: '活动抽水',
    name31: '退款金额',
    status1: '已结算',
    status2: '待结算',
    status3: '打和',
    status4: '异常',
    status5: '撤单',
    status6: '冻结',
    message1: '确定要执行撤单操作吗',
    message2: '复制成功',
    message3: '复制失败',
    tableTitle: '投注详情',
    tableName1: '订单编号',
    tableName2: '订单状态',
    tableName3: '期号',
    tableName4: '用户账号',
    tableName5: '游戏',
    tableName6: '投注金额',
    tableName7: '投注信息',
    tableName8: '实际支付金额',
    tableName9: '投注数',
    tableName10: '中奖注数',
    tableName11: '中奖信息',
    tableName12: '返点',
    tableName13: '退还金额',
    tableName14: '退水金额',
    tableName15: '中奖金额',
    tableName16: '盈亏金额',
    tableName17: '奖金抽水',
    tableName18: '结算时间',
    tableName19: '投注时间',
    tableName20: '开奖号码',
    tableName21: '倍数',
    tableName22: '订单号',
    tableName23: '关联订单号',
    tableName24: '最小投注金额',
    tableName25: '最大投注金额',
    tableName26: '最小中奖金额',
    tableName27: '最大中奖金额',
    label01: '账变记录',
    label02: '时间',
    label03: '订单类型',
    label04: '交易金额',
    label05: '关联订单号',
    label06: '备注',
    label07: '传输ID',
    label08: '注单详情',
    label09: '注：超过3分钟的已结算订单',
    label10: '注：只保留最新72小时订单记录',
    error1: '最小投注金额不允许大于最大投注金额',
    error2: '最小中奖金额不允许大于最大中奖金额'
  }
}
